import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import * as coreHttp from "@azure/core-http";
var packageName = "azure-storage-blob";
var packageVersion = "12.11.0";
export var StorageClientContext = /*#__PURE__*/function (_coreHttp$ServiceClie) {
  _inherits(StorageClientContext, _coreHttp$ServiceClie);

  /**
   * Initializes a new instance of the StorageClientContext class.
   * @param url The URL of the service account, container, or blob that is the target of the desired
   *            operation.
   * @param options The parameter options
   */
  function StorageClientContext(url, options) {
    var _this;

    _classCallCheck(this, StorageClientContext);

    if (url === undefined) {
      throw new Error("'url' cannot be null");
    } // Initializing default values for options


    if (!options) {
      options = {};
    }

    if (!options.userAgent) {
      var defaultUserAgent = coreHttp.getDefaultUserAgentValue();
      options.userAgent = "".concat(packageName, "/").concat(packageVersion, " ").concat(defaultUserAgent);
    }

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StorageClientContext).call(this, undefined, options));
    _this.requestContentType = "application/json; charset=utf-8";
    _this.baseUri = options.endpoint || "{url}"; // Parameter assignments

    _this.url = url; // Assigning values to Constant parameters

    _this.version = options.version || "2021-08-06";
    return _this;
  }

  return StorageClientContext;
}(coreHttp.ServiceClient);